import { clsx } from 'clsx'
import { type FC, type MouseEvent, type ReactElement } from 'react'

import { IconInfo } from '@redteclab/icons'

import { Link } from 'base-ui'

import { ProductBuyBoxDeliveryInfo } from '../ProductBuyBoxStockStatusAndDeliveryInfo/ProductBuyBoxDeliveryInfo'

type ProductBuyBoxNowDeliveryOptionProps = {
  additionalInfo?: ReactElement | null
  dotColor: string
  infoIconHandleClick?: (event: MouseEvent<HTMLElement>) => void
  message: ReactElement | null
}

export const ProductBuyBoxDeliveryOption: FC<
  ProductBuyBoxNowDeliveryOptionProps
> = ({ additionalInfo, dotColor, infoIconHandleClick, message }) => {
  return (
    <div className="my-2 flex items-center gap-3">
      <span className={clsx('inline-block size-2 rounded-full', dotColor)} />
      <div className="flex flex-1 flex-col items-start gap-0.5">
        <span className="text-s text-dark-primary-max">{message}</span>
        {additionalInfo ? (
          <span className="text-xs text-dark-primary-strong">
            {additionalInfo}
          </span>
        ) : (
          <ProductBuyBoxDeliveryInfo />
        )}
      </div>
      {infoIconHandleClick ? (
        <Link onClick={infoIconHandleClick} slots={{ root: 'button' }}>
          <IconInfo className="size-6 text-dark-primary-strong" />
        </Link>
      ) : null}
    </div>
  )
}
